import cookie from 'js-cookie';
import config from '../config';

export const setToken = (token: string) => cookie.set(config.TOKEN_KEY, token, { expires: 30 });

export const getToken = () => cookie.get(config.TOKEN_KEY) || '';

export const removeToken = () => cookie.remove(config.TOKEN_KEY);
